import React from "react";

interface Props {
  car: any;
  seat: string;
  enableAnimations: boolean;
  setSeat: (value: string) => void;
}

const SidebarSeats: React.FC<Props> = ({ car, enableAnimations, seat, setSeat }) => {

  React.useEffect(() => {
    return () => {
      setSeat('fl');
    };
  }, [setSeat]);

  return (
    <div className={`studio-sidebar-seats ${(enableAnimations === true) ? 'enabled':''}`}>
      <div className="studio-sidebar-seats-subcontainer">
        <div className='studio-sidebar-seats-title'>Distribución Asientos</div>
        <div className='studio-sidebar-icon-container'>
          <div className='studio-sidebar-icon-row'>
            <div className={`studio-sidebar-seat-icon fl ${(seat === 'fl') ? 'selected':''}`} onClick={() => {setSeat('fl')}}/>
            <div className={`studio-sidebar-seat-icon fr ${(seat === 'fr') ? 'selected':''}`} onClick={() => {setSeat('fr')}}/>
          </div>
          <div className='studio-sidebar-icon-row'>
            <div className={`studio-sidebar-seat-icon bl ${(seat === 'bl') ? 'selected':''}`} onClick={() => {setSeat('bl')}}/>
            <div className={`studio-sidebar-seat-icon br ${(seat === 'br') ? 'selected':''}`} onClick={() => {setSeat('br')}}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSeats;